import { render, staticRenderFns } from "./Kalligraphie.vue?vue&type=template&id=6489d7d6&scoped=true&"
var script = {}
import style0 from "./Kalligraphie.vue?vue&type=style&index=0&id=6489d7d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6489d7d6",
  null
  
)

export default component.exports